import { VALID_LOCATION_LEVELS } from '../constants';

/**
 * Validates and cleans a location level value
 * @param level - The location level to validate
 * @returns The validated location level string or undefined if invalid
 */
export const validateLocationLevel = (level: unknown): string | undefined => {
  if (
    typeof level === 'string' &&
    VALID_LOCATION_LEVELS.includes(
      level as (typeof VALID_LOCATION_LEVELS)[number],
    )
  ) {
    return level;
  }

  return undefined;
};
